/* Carte Google Maps interactive — embed sans clé API, centrée sur le siège */
const MAP_SRC =
  "https://maps.google.com/maps?q=60+Ter+Avenue+du+G%C3%A9n%C3%A9ral+de+Gaulle,+24660+Coulounieix-Chamiers&z=8&hl=fr&output=embed";

export const GoogleMap = ({ height = 480 }) => (
  <div className="rounded-2xl overflow-hidden shadow-subtle border border-line bg-surface-muted" data-testid="google-map">
    <iframe
      title="Carte des zones d'intervention HRC Rénovation — Coulounieix-Chamiers, Dordogne"
      src={MAP_SRC}
      width="100%"
      height={height}
      style={{ border: 0, display: "block" }}
      loading="lazy"
      allowFullScreen
      referrerPolicy="no-referrer-when-downgrade"
    />
  </div>
);
